import { useKidsPolicy } from "@/components/features/_hooks/use-kids-policy/use-kids-policy";
import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useKidsPolicyOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { kidsPolicy } = viewModel;

	return useKidsPolicy({ kidsPolicy, onSetViewModel });
};
